import type { ReactElement, SVGProps } from "react";
import { cn } from "@/lib/utils";

/**
 * SVG-based arc spinner — replaces CSS border spinners.
 * Renders a faint track circle with a rotating bold arc.
 */
export function ToolSpinnerIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  // r=7 in a 20×20 viewBox → circumference ≈ 43.98
  const r = 7;
  const circumference = 2 * Math.PI * r;
  const arcLength = circumference * 0.28; // 28% visible arc

  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 20 20"
      {...props}
      className={cn("animate-tool-arc-spin flex-shrink-0", props.className)}
    >
      {/* Faint track */}
      <circle
        cx="10"
        cy="10"
        r={r}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.12"
      />
      {/* Rotating arc */}
      <circle
        cx="10"
        cy="10"
        r={r}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray={`${arcLength} ${circumference - arcLength}`}
      />
    </svg>
  );
}
